(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('TempCustomerSectorSearch', TempCustomerSectorSearch);

    TempCustomerSectorSearch.$inject = ['$resource'];

    function TempCustomerSectorSearch($resource) {
        var resourceUrl =  'api/_search/temp-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
